var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "20px" },
          attrs: { disabled: _vm.disabled },
          on: { change: _vm.handleTierTypeChange },
          model: {
            value: _vm.tierType,
            callback: function ($$v) {
              _vm.tierType = $$v
            },
            expression: "tierType",
          },
        },
        [
          _c("el-radio", { attrs: { label: 0 } }, [_vm._v("区间阶梯")]),
          _c("el-radio", { attrs: { label: 1 } }, [_vm._v("增量阶梯")]),
        ],
        1
      ),
      !_vm.disabled
        ? _c("vxe-toolbar", {
            scopedSlots: _vm._u(
              [
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _c(
                        "vxe-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.addTable()
                            },
                          },
                        },
                        [_vm._v("添加行")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2279914514
            ),
          })
        : _vm._e(),
      _c(
        "vxe-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tierType === 0,
              expression: "tierType === 0",
            },
          ],
          attrs: { data: _vm.qjList },
        },
        [
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "tableNumMin",
              title: "宴席桌数下限",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 0,
                        placeholder: "宴席桌数下限1",
                      },
                      model: {
                        value: row.tableNumMin,
                        callback: function ($$v) {
                          _vm.$set(row, "tableNumMin", $$v)
                        },
                        expression: "row.tableNumMin",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "tableNumMax",
              title: "宴席桌数上限",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 0,
                        placeholder: "宴席桌数上限",
                      },
                      model: {
                        value: row.tableNumMax,
                        callback: function ($$v) {
                          _vm.$set(row, "tableNumMax", $$v)
                        },
                        expression: "row.tableNumMax",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "awardLat", title: "奖励纬度" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择奖励纬度",
                          disabled: rowIndex !== 0 || _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetAwardLatTypeChange(
                              $event,
                              rowIndex
                            )
                          },
                        },
                        model: {
                          value: row.awardLat,
                          callback: function ($$v) {
                            _vm.$set(row, "awardLat", $$v)
                          },
                          expression: "row.awardLat",
                        },
                      },
                      _vm._l(_vm.banquetAwardLatTypeList, function (item) {
                        return _c("el-option", {
                          key: item.dictCode,
                          attrs: {
                            label: item.dictValue,
                            value: item.dictCode,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "rewardType",
              title: "奖励类型",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择奖励类型",
                          disabled: rowIndex !== 0 || _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetAwardTypeChange($event, rowIndex)
                          },
                        },
                        model: {
                          value: row.rewardType,
                          callback: function ($$v) {
                            _vm.$set(row, "rewardType", $$v)
                          },
                          expression: "row.rewardType",
                        },
                      },
                      _vm._l(_vm.banquetAwardTypeList, function (item) {
                        return _c("el-option", {
                          key: item.dictCode,
                          attrs: {
                            label: item.dictValue,
                            value: item.dictCode,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "cashType", title: "兑付方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择兑付方式",
                          disabled: rowIndex !== 0 || _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetCashTypeChange($event, rowIndex)
                          },
                        },
                        model: {
                          value: row.cashType,
                          callback: function ($$v) {
                            _vm.$set(row, "cashType", $$v)
                          },
                          expression: "row.cashType",
                        },
                      },
                      _vm._l(
                        row.rewardType === "fee" || row.rewardType === "cash"
                          ? _vm.banquetCashTypeList
                          : _vm.banquetCashTypeList_1,
                        function (item) {
                          return _c("el-option", {
                            key: item.dictCode,
                            attrs: {
                              label: item.dictValue,
                              value: item.dictCode,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "productName",
              title: "奖励产品",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    row.rewardType === "fee" || row.rewardType === "cash"
                      ? _c(
                          "el-input",
                          {
                            attrs: { disabled: "", placeholder: "奖励产品" },
                            model: {
                              value: row.productName,
                              callback: function ($$v) {
                                _vm.$set(row, "productName", $$v)
                              },
                              expression: "row.productName",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(row.productName))])]
                        )
                      : _c(
                          "el-input",
                          {
                            attrs: {
                              disabled: _vm.disabled,
                              readonly: "",
                              placeholder: "奖励产品",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.productNameClick(rowIndex)
                              },
                            },
                            model: {
                              value: row.productName,
                              callback: function ($$v) {
                                _vm.$set(row, "productName", $$v)
                              },
                              expression: "row.productName",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(row.productName))])]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "rewardNum", title: "瓶数" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.rewardType == "fee" || row.rewardType == "cash"
                      ? _c("el-input", {
                          attrs: { disabled: "", placeholder: "瓶数" },
                          model: {
                            value: row.rewardNum,
                            callback: function ($$v) {
                              _vm.$set(row, "rewardNum", $$v)
                            },
                            expression: "row.rewardNum",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            disabled: _vm.disabled,
                            placeholder: "瓶数",
                          },
                          model: {
                            value: row.rewardNum,
                            callback: function ($$v) {
                              _vm.$set(row, "rewardNum", $$v)
                            },
                            expression: "row.rewardNum",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "rewardAmount",
              title: "每桌奖励费用",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.rewardType === "fee" || row.rewardType === "cash"
                      ? _c("el-input-number", {
                          attrs: {
                            disabled: _vm.disabled,
                            controls: false,
                            precision: 2,
                            placeholder: "每桌奖励费用",
                          },
                          model: {
                            value: row.rewardAmount,
                            callback: function ($$v) {
                              _vm.$set(row, "rewardAmount", $$v)
                            },
                            expression: "row.rewardAmount",
                          },
                        })
                      : _c("el-input-number", {
                          attrs: {
                            disabled: "",
                            controls: false,
                            precision: 2,
                            placeholder: "每桌奖励费用",
                          },
                          model: {
                            value: row.rewardAmount,
                            callback: function ($$v) {
                              _vm.$set(row, "rewardAmount", $$v)
                            },
                            expression: "row.rewardAmount",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          !_vm.disabled
            ? _c("vxe-column", {
                attrs: { title: "操作", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        var rowIndex = ref.rowIndex
                        return [
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletRow(row, rowIndex)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3921525946
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vxe-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tierType === 1,
              expression: "tierType === 1",
            },
          ],
          attrs: { data: _vm.dzList },
        },
        [
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "startNum", title: "起始桌数" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 0,
                        placeholder: "起始桌数",
                      },
                      model: {
                        value: row.startNum,
                        callback: function ($$v) {
                          _vm.$set(row, "startNum", $$v)
                        },
                        expression: "row.startNum",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "incrementNum",
              title: "递增桌数",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 0,
                        placeholder: "递增桌数",
                      },
                      model: {
                        value: row.incrementNum,
                        callback: function ($$v) {
                          _vm.$set(row, "incrementNum", $$v)
                        },
                        expression: "row.incrementNum",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "awardLat", title: "奖励纬度" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择奖励纬度",
                          disabled: rowIndex !== 0 || _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetAwardLatTypeChange(
                              $event,
                              rowIndex
                            )
                          },
                        },
                        model: {
                          value: row.awardLat,
                          callback: function ($$v) {
                            _vm.$set(row, "awardLat", $$v)
                          },
                          expression: "row.awardLat",
                        },
                      },
                      _vm._l(_vm.banquetAwardLatTypeList, function (item) {
                        return _c("el-option", {
                          key: item.dictCode,
                          attrs: {
                            label: item.dictValue,
                            value: item.dictCode,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "rewardType",
              title: "奖励类型",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择奖励类型",
                          disabled: rowIndex !== 0 || _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetAwardTypeChange($event, rowIndex)
                          },
                        },
                        model: {
                          value: row.rewardType,
                          callback: function ($$v) {
                            _vm.$set(row, "rewardType", $$v)
                          },
                          expression: "row.rewardType",
                        },
                      },
                      _vm._l(_vm.banquetAwardTypeList, function (item) {
                        return _c("el-option", {
                          key: item.dictCode,
                          attrs: {
                            label: item.dictValue,
                            value: item.dictCode,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "cashType", title: "兑付方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择兑付方式",
                          disabled: rowIndex !== 0 || _vm.disabled,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.banquetCashTypeChange($event, rowIndex)
                          },
                        },
                        model: {
                          value: row.cashType,
                          callback: function ($$v) {
                            _vm.$set(row, "cashType", $$v)
                          },
                          expression: "row.cashType",
                        },
                      },
                      _vm._l(
                        row.rewardType === "fee" || row.rewardType === "cash"
                          ? _vm.banquetCashTypeList
                          : _vm.banquetCashTypeList_1,
                        function (item) {
                          return _c("el-option", {
                            key: item.dictCode,
                            attrs: {
                              label: item.dictValue,
                              value: item.dictCode,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "productName",
              title: "奖励产品",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    row.rewardType === "fee" || row.rewardType === "cash"
                      ? _c(
                          "el-input",
                          {
                            attrs: { disabled: "", placeholder: "奖励产品" },
                            model: {
                              value: row.productName,
                              callback: function ($$v) {
                                _vm.$set(row, "productName", $$v)
                              },
                              expression: "row.productName",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(row.productName))])]
                        )
                      : _c(
                          "el-input",
                          {
                            attrs: {
                              disabled: _vm.disabled,
                              readonly: "",
                              placeholder: "奖励产品",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.productNameClick(rowIndex)
                              },
                            },
                            model: {
                              value: row.productName,
                              callback: function ($$v) {
                                _vm.$set(row, "productName", $$v)
                              },
                              expression: "row.productName",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(row.productName))])]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "levelBottle",
              title: "每级递增瓶数",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.rewardType == "fee" || row.rewardType == "cash"
                      ? _c("el-input", {
                          attrs: { disabled: "", placeholder: "每级递增瓶数" },
                          model: {
                            value: row.levelBottle,
                            callback: function ($$v) {
                              _vm.$set(row, "levelBottle", $$v)
                            },
                            expression: "row.levelBottle",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            disabled: _vm.disabled,
                            placeholder: "每级递增瓶数",
                          },
                          model: {
                            value: row.levelBottle,
                            callback: function ($$v) {
                              _vm.$set(row, "levelBottle", $$v)
                            },
                            expression: "row.levelBottle",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "levelAmount",
              title: "每级递增费用",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 2,
                        placeholder: "每级递增费用",
                      },
                      model: {
                        value: row.levelAmount,
                        callback: function ($$v) {
                          _vm.$set(row, "levelAmount", $$v)
                        },
                        expression: "row.levelAmount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "roundingCoefficient",
              title: "取整系数",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        controls: false,
                        precision: 0,
                        placeholder: "取整系数",
                      },
                      model: {
                        value: row.roundingCoefficient,
                        callback: function ($$v) {
                          _vm.$set(row, "roundingCoefficient", $$v)
                        },
                        expression: "row.roundingCoefficient",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          !_vm.disabled
            ? _c("vxe-column", {
                attrs: { title: "操作", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        var rowIndex = ref.rowIndex
                        return [
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletRow(row, rowIndex)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3921525946
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }